import { render, staticRenderFns } from "./SelectBox.vue?vue&type=template&id=4a39cd87&scoped=true"
import script from "./SelectBox.vue?vue&type=script&lang=ts"
export * from "./SelectBox.vue?vue&type=script&lang=ts"
import style0 from "./SelectBox.vue?vue&type=style&index=0&id=4a39cd87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39cd87",
  null
  
)

export default component.exports